import React from "react";
import Navbar from "../layout/Navbar";
import productivity_img1 from "../assests/Images/productivity_1.jpg";
import productivity_img2 from "../assests/Images/productivity_sec2.jpg";
import process_icon from "../assests/Images/Process_icon.png";
import policy_icon from "../assests/Images/policy_icon.png";
import leadership_icon from "../assests/Images/leadership_icon.png";
import location_icon from "../assests/Images/location_icon.png";
import people_icon from "../assests/Images/people.png";
import progress_icon from "../assests/Images/progress.png";
import Footer from "../layout/Footer";
import { useInView } from "react-intersection-observer";
import WaveEffect from "../Components/WaveEffect";
import { IoIosSettings } from "react-icons/io";
import { MdPolicy } from "react-icons/md";
import { FaCrown } from "react-icons/fa";
import { ImLocation2 } from "react-icons/im";
import { BsFillPeopleFill } from "react-icons/bs";
import { GiProgression } from "react-icons/gi";

const Productivity = () => {
  const { ref: ref1, inView: inView1 } = useInView({
    triggerOnce: false,
    threshold: 0,
  });
  const { ref: ref2, inView: inView2 } = useInView({
    triggerOnce: false,
    threshold: 0,
  });
  const { ref: ref3, inView: inView3 } = useInView({
    triggerOnce: false,
    threshold: 0,
  });

  return (
    <>
      <Navbar />
      <div
        className="bg-cover bg-center h-[75vh] lg:h-[75vh] md:h-[500px] sm:h-[400px] "
        style={{ backgroundImage: `url(${productivity_img1})` }}
      >
        <div className="h-full bg-black bg-opacity-60 flex flex-col gap-6 items-center justify-center ">
          <WaveEffect
            text="Productivity"
            textClassName="text-white text-4xl lg:text-8xl xl:text-8xl 2xl:text-8xl font-bold"
          />
          <div className="h-1 lg:h-2 xl:h-2 2xl:h-2  w-12 bg-white" />
          <p className=" text-white text-center lg:text-2xl xl:text-2xl 2xl:text-2xl mt-3">
            With our years of experience we empower your productivity with
            actionable steps.
          </p>
        </div>
      </div>

      <section className="py-20 px-16">
        <div className="w-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center w-fit">
            <div className="relative">
              <img
                src={productivity_img2}
                alt="Wooden blocks with red arrow pointing upward symbolizing growth and improvement"
                width={600}
                height={400}
                className="rounded-2xl shadow-2xl"
              />
            </div>

            <div>
              <h1 className="mb-6 bg-red-100 font-bold text-red-700 w-fit rounded-3xl text-sm px-4 py-2">
                EXECUTIVE EXCELLENCE
              </h1>
              <h1 className="text-4xl font-bold  text-gray-900 mb-6 leading-tight">
                PRODUCTIVITY IMPROVEMENT
                <br />
                <span className="text-red-600">INTERVENTIONS</span>
              </h1>
              <p className="text-lg text-gray-600 mb-8 w-fit ">
                An organization that fails to improve is destined to stagnate.
                Many productivity improvement programs are developed, and as
                people process of technology change, often resulting in
                declining productivity, morale outcomes. The key issue is that
                the people involved in implementing these improvements or
                systems are often overlooked.
              </p>
              <p className="text-lg text-gray-600 mb-8 w-fit leading-relaxed">
                Our approach to productivity is straightforward—we focus on both
                the organization and its people to cultivate a culture of
                performance improvement within a people-centered environment. We
                offer a holistic approach to Productivity Improvement, ensuring
                the effective utilization of all resources. Quantum Improvement,
                strategic energy and cost reduction.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 px-16 bg-gray-50">
        <div className="container ">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Change Management Partnership
            </h2>
            <p className="text-lg  max-w-5xl mx-auto leading-relaxed">
              Change is constant, but mismanaged change can lead to long term
              issues within an organization. At People Process Tack, we partner
              with you as a trusted ally to navigate these challenges. We
              collaborate with your senior management and leadership to plan,
              strategize, and implement organization-wide changes in key areas
              such as:
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8 mb-20">
            <div className="border-0 shadow-lg bg-blue-100 hover:shadow-xl transition-all duration-300 text-center group">
              <div className="p-8">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-red-600 transition-colors">
                  <IoIosSettings className="w-8 h-8 text-red-600 group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Process
                </h3>
              </div>
            </div>

            <div className="border-0 shadow-lg bg-blue-100 hover:shadow-xl transition-all duration-300 text-center group">
              <div className="p-8">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-red-600 transition-colors">
                  <MdPolicy className="w-8 h-8 text-red-600 group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Policy</h3>
              </div>
            </div>

            <div className="border-0 shadow-lg bg-blue-100 hover:shadow-xl transition-all duration-300 text-center group">
              <div className="p-8">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-red-600 transition-colors">
                  <FaCrown className="w-8 h-8 text-red-600 group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Leadership
                </h3>
              </div>
            </div>

            <div className="border-0 shadow-lg bg-blue-100 hover:shadow-xl transition-all duration-300 text-center group">
              <div className="p-8">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-red-600 transition-colors">
                  <ImLocation2 className="w-8 h-8 text-red-600 group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Location
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="px-16 py-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Productivity Interventions
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          <div className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 text-center">
            <div className="pb-4">
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <BsFillPeopleFill className="w-10 h-10 text-red-600" />
              </div>
              <h1 className="text-2xl font-bold text-gray-900">People</h1>
            </div>
            <div className="px-8 pb-8">
              <ul className="text-left space-y-3 text-gray-600">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                  <span>Kaizen Events</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                  <span>Small Group Activities</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 text-center">
            <div className="pb-4">
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <IoIosSettings className="w-10 h-10 text-red-600" />
              </div>
              <h1 className="text-2xl font-bold text-gray-900">Process</h1>
            </div>
            <div className="px-8 pb-8">
              <ul className="text-left space-y-3 text-gray-600">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                  <span>Lean Manufacturing</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                  <span>Waste Elimination</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                  <span>Process Simplification</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 text-center">
            <div className="pb-4">
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <GiProgression className="w-10 h-10 text-red-600" />
              </div>
              <h1 className="text-2xl font-bold text-gray-900">Progress</h1>
            </div>
            <div className="px-8 pb-8">
              <ul className="text-left space-y-3 text-gray-600">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                  <span>Manpower Optimization</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                  <span>Productivity standards</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                  <span>Incentive schemes</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Productivity;
